// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HowItWorks-page-Zu_7T {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.HowItWorks-wrap-WReu2 {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

.HowItWorks-sec-NsNDB {
  padding: 56px 0;
}

.HowItWorks-alt-mhgt3 {
  background: #f7f8f9;
}

.HowItWorks-h2-Gdmhm {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 8px;
}

.HowItWorks-lead-_mEMS {
  text-align: center;
  color: var(--muted);
  font-size: 17px;
  margin: 0 auto 34px;
  max-width: 560px;
}

.HowItWorks-twoCol-hDEPS {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.HowItWorks-modeCard-qfd9I {
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 28px 26px;
  background: #fff;
}

.HowItWorks-modeTag-c9jEU {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--red);
  background: #fff0ef;
  padding: 6px 12px;
  border-radius: 999px;
  margin-bottom: 18px;
}

.HowItWorks-modeTagAlt-jtpDo {
  color: var(--green-d);
  background: #e4f6f3;
}

.HowItWorks-modeNote-ul8xF {
  margin: 18px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--muted);
}

.HowItWorks-proBand-p_hsT {
  background: linear-gradient(135deg, #14171a, #20262c);
  color: #fff;
  padding: 40px 0;
}

.HowItWorks-proInner-YCdQQ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 24px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.HowItWorks-proTitle-_DyEP {
  font-size: clamp(20px, 3vw, 26px);
  font-weight: 800;
  margin: 0 0 6px;
  color: #fff;
}

.HowItWorks-proText-J96GN {
  margin: 0;
  opacity: 0.85;
  font-size: 16px;
}

.HowItWorks-proBtn-AptTX {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 48px;
  padding: 13px 26px;
  border-radius: 14px;
  background: var(--red);
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, transform 0.16s;
  transition: background 0.16s, transform 0.16s, -webkit-transform 0.16s;
}

.HowItWorks-proBtn-AptTX:hover {
  background: var(--red-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

.HowItWorks-faqMore-YfSpV {
  text-align: center;
  margin-top: 22px;
}

.HowItWorks-faqLink-KMFKp {
  color: var(--red);
  font-weight: 700;
  text-decoration: none;
}

.HowItWorks-faqLink-KMFKp:hover {
  text-decoration: underline;
}

@media (max-width: 820px) {
  .HowItWorks-twoCol-hDEPS {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 680px) {
  .HowItWorks-sec-NsNDB {
    padding: 44px 0;
  }
  .HowItWorks-proInner-YCdQQ {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    text-align: center;
  }
}

@media (prefers-color-scheme: dark) {
  .HowItWorks-page-Zu_7T {
    background: #14171a;
    color: #f3f4f6;
  }
  .HowItWorks-alt-mhgt3 {
    background: #1a1e22;
  }
  .HowItWorks-h2-Gdmhm {
    color: #f3f4f6;
  }
  .HowItWorks-lead-_mEMS,
  .HowItWorks-modeNote-ul8xF {
    color: #9aa3ad;
  }
  .HowItWorks-modeCard-qfd9I {
    background: #1d2125;
    border-color: #2c3137;
  }
  .HowItWorks-modeTag-c9jEU {
    background: rgba(232, 35, 43, 0.16);
  }
  .HowItWorks-modeTagAlt-jtpDo {
    background: rgba(22, 163, 74, 0.16);
    color: #5fd99a;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/how-it-works/HowItWorks.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,eAAe;AACjB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AACA;EACE,SAAS;EACT,aAAa;EACb,eAAe;AACjB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,6DAA6C;EAA7C,qDAA6C;EAA7C,6CAA6C;EAA7C,sEAA6C;AAC/C;;AACA;EACE,wBAAwB;EACxB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,cAAc;EAChB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.sec {\n  padding: 56px 0;\n}\n.alt {\n  background: #f7f8f9;\n}\n\n.h2 {\n  font-size: clamp(26px, 4vw, 36px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 8px;\n}\n.lead {\n  text-align: center;\n  color: var(--muted);\n  font-size: 17px;\n  margin: 0 auto 34px;\n  max-width: 560px;\n}\n\n.twoCol {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n.modeCard {\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 28px 26px;\n  background: #fff;\n}\n.modeTag {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--red);\n  background: #fff0ef;\n  padding: 6px 12px;\n  border-radius: 999px;\n  margin-bottom: 18px;\n}\n.modeTagAlt {\n  color: var(--green-d);\n  background: #e4f6f3;\n}\n.modeNote {\n  margin: 18px 0 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--muted);\n}\n\n.proBand {\n  background: linear-gradient(135deg, #14171a, #20262c);\n  color: #fff;\n  padding: 40px 0;\n}\n.proInner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n.proTitle {\n  font-size: clamp(20px, 3vw, 26px);\n  font-weight: 800;\n  margin: 0 0 6px;\n  color: #fff;\n}\n.proText {\n  margin: 0;\n  opacity: 0.85;\n  font-size: 16px;\n}\n.proBtn {\n  display: inline-flex;\n  align-items: center;\n  min-height: 48px;\n  padding: 13px 26px;\n  border-radius: 14px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 700;\n  text-decoration: none;\n  transition: background 0.16s, transform 0.16s;\n}\n.proBtn:hover {\n  background: var(--red-d);\n  transform: translateY(-2px);\n}\n\n.faqMore {\n  text-align: center;\n  margin-top: 22px;\n}\n.faqLink {\n  color: var(--red);\n  font-weight: 700;\n  text-decoration: none;\n}\n.faqLink:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 820px) {\n  .twoCol {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 680px) {\n  .sec {\n    padding: 44px 0;\n  }\n  .proInner {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .alt {\n    background: #1a1e22;\n  }\n  .h2 {\n    color: #f3f4f6;\n  }\n  .lead,\n  .modeNote {\n    color: #9aa3ad;\n  }\n  .modeCard {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .modeTag {\n    background: rgba(232, 35, 43, 0.16);\n  }\n  .modeTagAlt {\n    background: rgba(22, 163, 74, 0.16);\n    color: #5fd99a;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `HowItWorks-page-Zu_7T`,
	"wrap": `HowItWorks-wrap-WReu2`,
	"sec": `HowItWorks-sec-NsNDB`,
	"alt": `HowItWorks-alt-mhgt3`,
	"h2": `HowItWorks-h2-Gdmhm`,
	"lead": `HowItWorks-lead-_mEMS`,
	"twoCol": `HowItWorks-twoCol-hDEPS`,
	"modeCard": `HowItWorks-modeCard-qfd9I`,
	"modeTag": `HowItWorks-modeTag-c9jEU`,
	"modeTagAlt": `HowItWorks-modeTagAlt-jtpDo`,
	"modeNote": `HowItWorks-modeNote-ul8xF`,
	"proBand": `HowItWorks-proBand-p_hsT`,
	"proInner": `HowItWorks-proInner-YCdQQ`,
	"proTitle": `HowItWorks-proTitle-_DyEP`,
	"proText": `HowItWorks-proText-J96GN`,
	"proBtn": `HowItWorks-proBtn-AptTX`,
	"faqMore": `HowItWorks-faqMore-YfSpV`,
	"faqLink": `HowItWorks-faqLink-KMFKp`
};
module.exports = ___CSS_LOADER_EXPORT___;
